import { postRequest, getRequest } from "./requestClient";

export function login(params: AppAPI.LoginParams) {
  return postRequest<AppAPI.LoginResponse>("/auth/login", params);
}

export function refreshToken(refreshToken: string) {
  return postRequest<AppAPI.RefreshTokenResponse>("/auth/refresh-token", {
    refreshToken,
  });
}

export function getCurrentUser() {
  return getRequest<AppAPI.GetUserResponse>("/users/me");
}

export function logout() {
  return getRequest<AppAPI.Response<null>>("/auth/logout");
}
